module.exports = __webpack_public_path__ + "static/media/S (36).632c1865.jpg";